import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';



///import the components
import { AdminModule } from './admin/admin.module';
import { PublicModule } from './public/public.module';
import { AuthModule } from './auth/auth.module';

const modules: NgModule[] =[AdminModule,AuthModule]; 

const routes: Routes = [
  { path: '', redirectTo: '/admin/dashboard', pathMatch: 'full' },
];
@NgModule({
  imports: [ RouterModule.forRoot(routes),modules ],
  exports: [ RouterModule,modules ],
  providers:[]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts